const { BaseStorage } = require("@/storage/BaseStorage");
import * as Yup from "yup";

const storageKey = "of-saipos-config";

const eventKey = `${storageKey}:changed`;

export class SaiposTableConfiguration {
  /**
   *
   * @param {Object} options - Opções de configuração
   * @param {string} options.externalId - Id da mesa ou comanda
   * @param {string} options.codStore - Código da unidade
   * @param {string} options.idPartner - Código da integração
   * @param {BaseStorage} options.storage - Instância do serviço de armazenamento
   */

  constructor({ externalId, codStore, idPartner, callWaiterSku, storage }) {
    /**
     * Id da mesa ou comanda
     * @type {string}
     */
    this.externalId = externalId;

    /**
     * Código da unidade
     * @type {string}
     */
    this.codStore = codStore;

    /**
     * Código da integração
     * @type {string}
     */
    this.idPartner = idPartner;

    /**
     * SKU do produto (Chamar garçom)
     * @type {string}
     */
    this.callWaiterSku = callWaiterSku;

    /**
     * Instancia do serviço de armazenamento.
     * @type {BaseStorage}
     */
    this.storage = storage;
  }

  static fromStorage() {
    const storage = new BaseStorage({ key: storageKey });

    const configs = storage.getData();

    const tableConfiguration = new SaiposTableConfiguration({
      ...configs,
      storage,
    });

    tableConfiguration.updateStatus();

    return tableConfiguration;
  }

  update(configs) {
    console.log("UPDATE");
    const currentKeys = Object.keys(this);
    const updatedKeys = Object.keys(configs || {});

    for (const field of currentKeys) {
      this[field] = updatedKeys.includes(field) ? configs[field] : this[field];
    }

    this.updateStatus();

    if (window) {
      this.storage.setData(this);

      window.dispatchEvent(
        new CustomEvent(eventKey, {
          detail: { storage: this.storage.id, key: this.storage.getKey() },
        }),
      );
    }
  }

  addListener(handler) {
    if (!this.listener) {
      this.listener = (event) => {
        if (event.detail.key === this.storage.getKey()) {
          handler();
        }
      };
      window.addEventListener(eventKey, this.listener);
    }
  }

  removeListener() {
    if (this.listener) {
      window.removeEventListener(eventKey, this.listener);
      this.listener = null;
    }
  }

  export() {
    const { storage, listener, ...configs } = this;
    return { ...configs };
  }

  isConfigured() {
    return !!(this.externalId && this.codStore && this.idPartner);
  }

  updateStatus() {
    this.configured = this.isConfigured();
  }

  import(rawConfig) {
    try {
      const configObject = JSON.parse(rawConfig);

      const schema = Yup.object({
        codStore: Yup.string().required("Campo obrigatório"),
        idPartner: Yup.string().required("Campo obrigatório"),
        callWaiterSku: Yup.string().optional(),
      });

      const configs = schema.validateSync(configObject, { strict: true });

      this.update(configs);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const field = err.path;
        const error = err.errors[0];
        const errorMessage = [field, error].filter(Boolean).join(" - ");
        throw new Error(errorMessage);
      }

      throw new Error(err.message);
    }
  }
}
